import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../config';

/**
 * Bloque tipo "waitlist" para capturar interes en Pago Movil (Venezuela).
 * No es un metodo de pago activo; informa al usuario que se le avisara cuando este disponible.
 */
const PagoMovilWaitlist = () => {
  const [registered, setRegistered] = useState(null);
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [bank, setBank] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/waitlist/pago-movil/mine`).then(r => {
      setRegistered(r.data?.registered ? r.data.entry : false);
    }).catch(() => setRegistered(false));
  }, []);

  const submit = async () => {
    if (!email && !phone) { setError('Indica email o telefono'); return; }
    setSubmitting(true);
    setError(null);
    try {
      const res = await axios.post(`${API}/waitlist/pago-movil`, {
        email: email || null,
        phone: phone || null,
        bank: bank || null,
      });
      setRegistered({ email, phone, bank, created_at: new Date().toISOString() });
    } catch (e) {
      setError(e?.response?.data?.detail || 'Error al registrar');
    } finally {
      setSubmitting(false);
    }
  };

  if (registered === null) return null;

  if (registered) {
    return (
      <div data-testid="pago-movil-registered" className="rounded-2xl border border-emerald-200 bg-emerald-50 p-5">
        <div className="flex items-start gap-3">
          <div className="text-2xl">{'\u2705'}</div>
          <div>
            <h3 className="font-bold text-emerald-900">Ya estas en la lista</h3>
            <p className="text-xs text-emerald-800 mt-1">
              Te avisaremos por {registered.email ? `email (${registered.email})` : `telefono (${registered.phone})`} cuando habilitemos Pago Movil.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="pago-movil-waitlist" className="rounded-2xl border border-purple-200 bg-gradient-to-br from-purple-50 to-pink-50 p-5 space-y-3">
      <div className="flex items-start gap-3">
        <div className="text-2xl">{'\u{1F4F1}'}</div>
        <div className="flex-1">
          <h3 className="font-bold text-purple-900">Pago Movil <span className="text-[10px] font-normal px-2 py-0.5 rounded-full bg-purple-200 text-purple-800 align-middle ml-1">Proximamente</span></h3>
          <p className="text-xs text-purple-800 mt-1">
            Estamos trabajando para habilitar el pago directo desde tu banco venezolano.
            Dejanos tus datos y te avisaremos apenas este disponible.
          </p>
        </div>
      </div>
      <div className="grid sm:grid-cols-2 gap-2">
        <input
          type="email"
          placeholder="Tu email (opcional)"
          value={email}
          onChange={e => setEmail(e.target.value)}
          data-testid="pago-movil-email"
          className="px-3 py-2 border border-purple-200 rounded text-sm bg-white"
        />
        <input
          type="tel"
          placeholder="Tu telefono (opcional)"
          value={phone}
          onChange={e => setPhone(e.target.value)}
          data-testid="pago-movil-phone"
          className="px-3 py-2 border border-purple-200 rounded text-sm bg-white"
        />
      </div>
      <select
        value={bank}
        onChange={e => setBank(e.target.value)}
        data-testid="pago-movil-bank"
        className="w-full px-3 py-2 border border-purple-200 rounded text-sm bg-white"
      >
        <option value="">Banco que usas (opcional)</option>
        <option value="banesco">Banesco</option>
        <option value="mercantil">Mercantil</option>
        <option value="bdv">Banco de Venezuela</option>
        <option value="provincial">Provincial (BBVA)</option>
        <option value="bnc">BNC</option>
        <option value="bancaribe">Bancaribe</option>
        <option value="otro">Otro</option>
      </select>
      {error && <div className="text-xs text-red-700 bg-red-50 rounded p-2">{error}</div>}
      <button
        onClick={submit}
        disabled={submitting}
        data-testid="pago-movil-submit"
        className="w-full py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-white text-sm font-semibold disabled:opacity-50"
      >
        {submitting ? 'Registrando...' : 'Avisame cuando este listo'}
      </button>
    </div>
  );
};

export default PagoMovilWaitlist;
